import { POST } from 'api'

const uniqueSubjectIds = ids => [...new Set((ids || []).filter(Boolean))]

export const findNotebooksByAgoraSubjects = agoraSubjectIds => {
  const subjectIds = uniqueSubjectIds(agoraSubjectIds)
  if (!subjectIds.length) return Promise.resolve([])
  return POST({
    url: 'v2/teachers/material-batch/notebooks',
    data: { subjectIds }
  })
}

export const findVideosByAgoraSubjects = agoraSubjectIds => {
  const subjectIds = uniqueSubjectIds(agoraSubjectIds)
  if (!subjectIds.length) return Promise.resolve([])
  return POST({
    url: 'v2/teachers/material-batch/videos',
    data: { subjectIds }
  })
}
